import { supabase } from '../lib/supabase'
import { Check, X } from 'lucide-react'

const STARTER_LINK  = 'https://buy.stripe.com/7sY5kE1dI4q2afsfRf7Vm04'
const STANDARD_LINK = 'https://buy.stripe.com/dRm7sM5tYaOq9bocF37Vm05'
const PRO_LINK      = 'https://buy.stripe.com/cNieVee0u2hUdrEeNb7Vm03'

const PLANS = [
  {
    id: 'starter',
    name: 'Starter',
    subtitle: 'Small Schools · Seasonal Operations',
    price: '$599',
    billing: 'billed once per year',
    monthly: '$50 / mo equivalent',
    link: STARTER_LINK,
    accent: '#0B1E3D',
    dark: false,
    features: [
      { label: 'Scheduling & Calendar', on: true },
      { label: 'Instructor Management', on: true },
      { label: 'Instructor Approvals', on: true },
      { label: 'Lesson Pricing', on: true },
      { label: 'Stripe Payments', on: true },
      { label: 'Live Weather & Surf', on: true },
      { label: 'Up to 7 Instructors', on: true },
      { label: 'AI Instructor Matching', on: false },
      { label: 'Payroll & CSV Export', on: false },
      { label: 'Analytics Dashboard', on: false },
    ],
  },
  {
    id: 'standard',
    name: 'Standard',
    subtitle: 'Growing Schools · Full Operations',
    price: '$1,299',
    billing: 'billed once per year',
    monthly: '$108.25 / mo equivalent',
    link: STANDARD_LINK,
    accent: '#0EAAA4',
    dark: false,
    features: [
      { label: 'Scheduling & Calendar', on: true },
      { label: 'Instructor Management', on: true },
      { label: 'Instructor Approvals', on: true },
      { label: 'Lesson Pricing', on: true },
      { label: 'Stripe Payments', on: true },
      { label: 'Live Weather & Surf', on: true },
      { label: 'Up to 14 Instructors', on: true },
      { label: 'AI Instructor Matching', on: true },
      { label: 'Payroll & CSV Export', on: true },
      { label: 'Analytics Dashboard', on: false },
    ],
  },
  {
    id: 'pro',
    name: 'Pro',
    subtitle: 'Full Platform · Unlimited Instructors',
    price: '$2,199',
    billing: 'billed once per year',
    monthly: '$183 / mo equivalent',
    link: PRO_LINK,
    accent: '#E8614A',
    dark: true,
    features: [
      { label: 'Scheduling & Calendar', on: true },
      { label: 'Instructor Management', on: true },
      { label: 'Instructor Approvals', on: true },
      { label: 'Lesson Pricing', on: true },
      { label: 'Stripe Payments', on: true },
      { label: 'Live Weather & Surf', on: true },
      { label: 'Unlimited Instructors', on: true },
      { label: 'AI Instructor Matching', on: true },
      { label: 'Payroll & CSV Export', on: true },
      { label: 'Analytics Dashboard', on: true },
    ],
  },
]

export default function SubscriptionGate({ onSuccess }) {
  const urlParams = new URLSearchParams(window.location.search)
  if (urlParams.get('subscribed') === 'true' && onSuccess) {
    onSuccess()
    return null
  }

  const handleSubscribe = (tier, link) => {
    localStorage.setItem('pendingTier', tier)
    window.location.href = link
  }

  const handleSignOut = async () => {
    await supabase.auth.signOut()
    window.location.reload()
  }

  return (
    <div style={{ minHeight: '100vh', background: '#F0EDE4', fontFamily: 'DM Sans, sans-serif', color: '#0B1E3D' }}>
      {/* Header */}
      <div style={{ background: '#0B1E3D', padding: '18px 28px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div style={{ fontFamily: 'Playfair Display, serif', fontSize: 22, color: '#E8614A', fontWeight: 700 }}>
          🌊 WaveSync
        </div>
        <button onClick={handleSignOut} style={{ background: 'transparent', border: '1px solid rgba(255,255,255,0.2)', color: 'rgba(255,255,255,0.6)', padding: '7px 16px', borderRadius: 8, cursor: 'pointer', fontSize: 13, fontFamily: 'DM Sans, sans-serif' }}>
          Sign Out
        </button>
      </div>

      <div style={{ maxWidth: 1060, margin: '0 auto', padding: '48px 24px 80px' }}>
        <div style={{ textAlign: 'center', marginBottom: 40 }}>
          <h1 style={{ fontFamily: 'Playfair Display, serif', fontSize: 'clamp(28px, 5vw, 40px)', fontWeight: 900, color: '#0B1E3D', margin: '0 0 10px' }}>
            Choose Your Plan
          </h1>
          <p style={{ fontSize: 15, color: '#6b7280', lineHeight: 1.6, margin: 0 }}>
            Everything you need to run your surf school — pick the plan that fits.
          </p>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: 20, marginBottom: 48 }}>
          {PLANS.map(plan => (
            <div
              key={plan.id}
              style={{
                background: plan.dark ? '#0B1E3D' : 'white',
                borderRadius: 20,
                overflow: 'hidden',
                boxShadow: plan.dark ? '0 8px 32px rgba(11,30,61,0.18)' : '0 4px 20px rgba(11,30,61,0.08)',
                border: `2px solid ${plan.accent}`,
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              {/* Header band */}
              <div style={{ background: plan.dark ? 'rgba(255,255,255,0.05)' : plan.id === 'standard' ? 'rgba(14,170,164,0.08)' : '#F5EDD8', padding: '14px 24px', textAlign: 'center' }}>
                <div style={{ fontSize: 14, fontWeight: 700, color: plan.dark ? '#F5EDD8' : '#0B1E3D', letterSpacing: 0.5 }}>{plan.name}</div>
                <div style={{ fontSize: 11, color: plan.dark ? 'rgba(245,237,216,0.5)' : '#9ca3af', marginTop: 3 }}>{plan.subtitle}</div>
              </div>

              {/* Pricing */}
              <div style={{ padding: '28px 28px 20px', textAlign: 'center' }}>
                {plan.id === 'pro' && (
                  <div style={{ display: 'inline-block', background: '#E8614A', color: 'white', fontSize: 10, fontWeight: 700, padding: '3px 10px', borderRadius: 20, letterSpacing: 0.5, textTransform: 'uppercase', marginBottom: 12 }}>
                    Most Popular
                  </div>
                )}
                <div style={{ marginBottom: 4 }}>
                  <span style={{ fontFamily: 'Playfair Display, serif', fontSize: 56, fontWeight: 900, color: plan.dark ? 'white' : '#0B1E3D', lineHeight: 1 }}>{plan.price}</span>
                </div>
                <div style={{ fontSize: 13, color: plan.dark ? 'rgba(255,255,255,0.45)' : '#9ca3af', marginBottom: 4 }}>{plan.billing}</div>
                <div style={{ fontSize: 12, color: plan.dark ? 'rgba(255,255,255,0.28)' : '#c0c7d0', marginBottom: 24 }}>{plan.monthly}</div>
                <button
                  onClick={() => handleSubscribe(plan.id, plan.link)}
                  style={{
                    width: '100%', padding: '14px', border: 'none',
                    background: plan.accent,
                    borderRadius: 12, color: 'white', fontSize: 15, fontWeight: 700,
                    cursor: 'pointer', fontFamily: 'DM Sans, sans-serif',
                    boxShadow: `0 4px 14px ${plan.accent}55`,
                  }}
                >
                  Get {plan.name} →
                </button>
              </div>

              {/* Feature list */}
              <div style={{ borderTop: `1px solid ${plan.dark ? 'rgba(255,255,255,0.07)' : 'rgba(11,30,61,0.06)'}`, padding: '20px 28px 28px', flex: 1 }}>
                {plan.features.map((f, i) => (
                  <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '6px 0' }}>
                    {f.on
                      ? <Check size={15} color="#0EAAA4" style={{ flexShrink: 0 }} />
                      : <X size={15} color={plan.dark ? 'rgba(255,255,255,0.2)' : '#d1d5db'} style={{ flexShrink: 0 }} />
                    }
                    <span style={{ fontSize: 13, color: f.on ? (plan.dark ? 'rgba(255,255,255,0.75)' : '#374151') : (plan.dark ? 'rgba(255,255,255,0.25)' : '#9ca3af') }}>
                      {f.label}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        <div style={{ textAlign: 'center', fontSize: 12, color: '#9ca3af' }}>
          Secured by Stripe · Cancel anytime
        </div>
      </div>
    </div>
  )
}
